function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "7uL5",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d7adfe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ae96fc"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.898 8.467)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 33,
  height: 48,
  transform: "translate(-0.898 -8.467)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22154,22361.824a1.746,1.746,0,0,1-1.066-2.223l3.688-14.826-10.045.154a1.4,1.4,0,0,1-.779-.531,2.145,2.145,0,0,1,.215-2.66l17.7-19.889a1.49,1.49,0,0,1,1.477-.5,1.755,1.755,0,0,1,1.082,2.227l-3.5,14.867,9.8-.08a1.382,1.382,0,0,1,.779.512,2.162,2.162,0,0,1-.219,2.676l-17.635,19.77a1.584,1.584,0,0,1-1.148.549A1.369,1.369,0,0,1,22154,22361.824Z",
  transform: "translate(-22144.031 -22326.076)",
  fill: "url(#7uL5)"
}));

function SvgLightningActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningActive);
export default __webpack_public_path__ + "static/media/lightning-active.ec94ca8c.svg";
export { ForwardRef as ReactComponent };